import { RootState } from '../../../store';

export const selectUserModule = (state: RootState) => state.user;
export const selectUserProfile = (state: RootState) => state.user.profile;
export const selectUserStatus = (state: RootState) => state.user.status;
export const selectUserError = (state: RootState) => state.user.error;

// Update 관련 selectors (PUT /users/put)
export const selectUserUpdateStatus = (state: RootState) => state.user.updateStatus;
export const selectUserUpdateError = (state: RootState) => state.user.updateError;
export const selectLastUpdateResponse = (state: RootState) => state.user.lastUpdateResponse;

// Patch 관련 selectors (PATCH /users/patch)
export const selectUserPatchStatus = (state: RootState) => state.user.patchStatus;
export const selectUserPatchError = (state: RootState) => state.user.patchError;
export const selectLastPatchResponse = (state: RootState) => state.user.lastPatchResponse;

// Search 관련 selectors (POST /users/m/sch)
export const selectUserSearchStatus = (state: RootState) => state.user.searchStatus;
export const selectUserSearchError = (state: RootState) => state.user.searchError;
export const selectUserSearchResults = (state: RootState) => state.user.searchResults;
export const selectUserSearchMeta = (state: RootState) => state.user.searchMeta;

// Create 관련 selectors (POST /users)
export const selectUserCreateStatus = (state: RootState) => state.user.createStatus;
export const selectUserCreateError = (state: RootState) => state.user.createError;
export const selectLastCreateResponse = (state: RootState) => state.user.lastCreateResponse;

// GetUser 관련 selectors (POST /users/get)
export const selectGetUserStatus = (state: RootState) => state.user.getUserStatus;
export const selectGetUserError = (state: RootState) => state.user.getUserError;
export const selectFetchedUser = (state: RootState) => state.user.fetchedUser;

